export const MIN_FOLLOWER = 10000;
export const MAX_FOLLOWER = 100000;
export const MIN_ER = 1;
export const MAX_ER = 20;
